import { Component, ViewChild } from "@angular/core";
import { BaseListComponent } from "../../SharedModule/BaseListComponent/base-list.component";
import { Pagination } from "../../model/Helpers/Pagination";
import { SortInfo } from "../../model/Helpers/SortInfo";
import { Filter } from "../../model/Helpers/Filter";
import { MatSort } from "@angular/material/sort";
import { merge } from "rxjs/observable/merge";
import {TransportStatsService} from '../../services/transport-stats.service';
import {TransportStatsDataSource} from '../../model/DataSources/TransportStatsDataSource';
import {TransportDataSource} from '../../model/DataSources/TransportDataSource';
import {TransportService} from '../../services/transport.service';
import {ContractState} from '../../model/Entities/ContractState';
import {Contract} from '../../model/Entities/Contract';
import { Router } from '@angular/router';
import {Transport} from '../../model/Entities/Transport';
import {TransportDialogComponent} from '../../ContractsModule/TransportDialogComponent/transport.dialog.component';
import {DialogService} from '../../services/dialog.service';
import {SnackService} from '../../services/snack.service';
import {
    TransportDeleteConfirmDialogComponent
} from '../../ContractsModule/TransportDeleteConfirmDialogComponent/transport-delete-confirm.dialog.component';
import {TransportRepeatDialogComponent} from '../TransportRepeatDialogComponent/transportRepeat.dialog.component';
import {TransportRepeat} from '../../model/Entities/TransportRepeat';
import {RepeatTransportService} from '../../services/repeat-transport.service';
import {RepeatTransportDataSource} from '../../model/DataSources/RepeatTransportDataSource';

@Component({
    selector: "transport-repeat",
    templateUrl: "./transportRepeat.component.html",
})
export class TransportRepeatComponent extends BaseListComponent {
    displayedColumns: string[] = [
        "title",
        "transport_from",
        "transport_to",
        "note",
        "readablerrule",
        "address",
        "drivers",
        "tags",
        "actions",
    ];


    @ViewChild(MatSort) sort: MatSort;

    constructor(
        private repeatTransportService: RepeatTransportService,
        private dialogService: DialogService,
        private snackService: SnackService,
        private router: Router,
    ) {
        super();
        this.defaultFilters = {
            from: new Date(new Date().setHours(0, 0, 0, 0)),
            to: new Date(new Date().setHours(23, 59, 59, 999)),
            predefinedPeriod: "custom",
        };
        this.filters = {
            from: new Date(new Date().setHours(0, 0, 0, 0)),
            to: new Date(new Date().setHours(23, 59, 59, 999)),
            predefinedPeriod: "custom",
        };
        this.resetFilters(false);

        this.dataSource = new RepeatTransportDataSource(this.repeatTransportService);
    }

    ngAfterViewInit() {
        this.prepareDataLoading();
        this.loadData();
    }


    prepareDataLoading() {
        merge(
            this.paginator.page,
            this.sort.sortChange,
            this.dataChangedEventSubject
        ).subscribe(() => {
            if (!this.dataSource) {
                return;
            }
            this.dataSource.loadPage(
                new Pagination(this.paginator.pageSize, this.paginator.pageSize * this.paginator.pageIndex),
                new SortInfo(this.sort.active, this.sort.direction),
                this.getFilters(),
                {
                    expand: 'users,readablerrule'
                });
        });
    }

    loadData() {
        this.dataSource.loadPage(
            new Pagination(
                this.paginator.pageSize,
                this.pageSize * this.initialPageIndex
            ),
            null,
            this.getFilters(),
            {
                expand: 'users,readablerrule'
            }
        );
    }

    getFilters() {
        const filters: Filter[] = [];
        return filters;
    }

    formatTime(time) {
        if (time.h) {
            return (time.h < 10 ? '0' + time.h : time.h) + ':' + (time.i < 10 ? '0' + time.i : time.i);
        }
        return time;
    }

    setPredefinedPeriod(period: string): void {
        this.filters.predefinedPeriod = period;

        const now = new Date();

        switch (period) {
            case "lastMonth":
                const lastMonth = new Date(
                    now.getFullYear(),
                    now.getMonth() - 1,
                    1
                );
                const lastMonthEnd = new Date(
                    now.getFullYear(),
                    now.getMonth(),
                    0
                );
                this.filters.from = lastMonth;
                this.filters.to = lastMonthEnd;
                break;

            case "thisYear":
                const yearStart = new Date(now.getFullYear(), 0, 1);
                const yearEnd = new Date(now.getFullYear(), 11, 31);
                this.filters.from = yearStart;
                this.filters.to = yearEnd;
                break;

            case "custom":
                // Keep current dates, just change the period
                break;
        }

        this.reloadPage();
    }

    onDateChange(): void {
        // When user manually changes dates, switch to custom period
        this.filters.predefinedPeriod = "custom";
        this.reloadPage();
    }

    protected readonly contractStateClass = ContractState;

    showContractDetail(contract: Contract): void {
        this.router.navigate([`/contract/${contract.id}`]);
    }

    editTransport(transport) {
        this.openTransportDialog(transport);
    }

    deleteTransport(transport) {
        this.dialogService.showDialog(TransportDeleteConfirmDialogComponent, {
            'transport': transport,
        }).afterClosed().subscribe((result) => {
                if (result) {
                    this.repeatTransportService.delete(transport.id).subscribe(() => {
                        this.snackService.showSuccess(`Opakovaná doprava byla smazána`);
                        this.reloadPage();
                    });
                }
            }
        );
    }

    private openTransportDialog(transportRepeat: TransportRepeat): void {
        if (transportRepeat.id) {
            transportRepeat.fromTime = this.formatTime(transportRepeat.fromTime);
            transportRepeat.toTime = this.formatTime(transportRepeat.toTime);
        }
        this.dialogService.showDialog(TransportRepeatDialogComponent, {
            'transportRepeat': transportRepeat,
        }, 1000).afterClosed().subscribe((result) => {
               console.log(result);
               if (result) {
                   if (!result.id) {
                       // create
                       this.repeatTransportService.save(result).subscribe((t: Transport) => {
                           this.snackService.showSuccess(`Opakovaná doprava byla přidána`);
                           this.reloadPage();
                       });
                   } else {
                       // update
                       this.repeatTransportService.update(result.id, result).subscribe((t: Transport) => {
                           this.snackService.showSuccess(`Opakovaná doprava byla upravena`);
                           this.reloadPage();
                       });
                   }

               }
            }
        );
    };

    addRepeatTransport() {
        const transportRepeat = new TransportRepeat();
        this.openTransportDialog(transportRepeat);

    }
}



// WEBPACK FOOTER //
// /app/src/TransportModule/TransportRepeatComponent/transportRepeat.component.ts